<template>
  <!-- Mais um tile do bloco de oportunidades: a classe `featured` vem do
       Vacancy.vue, que desenha a moldura dos vizinhos. O card inteiro e a area
       clicavel, como nos vizinhos -- nenhum deles tem botao. -->
  <div class="featured install-card" @click="install">
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="40" height="40" rx="20" :fill="brandColor" fill-opacity="0.18"/>
      <!-- Silhueta preenchida e centrada como a dos vizinhos: o desenho vem de
           um viewBox de 24 e o translate apenas o encaixa no circulo de 40. -->
      <g transform="translate(8 7.75)">
        <path d="M12 3.5a1 1 0 0 1 1 1v8.09l2.3-2.3a1 1 0 1 1 1.4 1.42l-4 4a1 1 0 0 1-1.4 0l-4-4a1 1 0 1 1 1.4-1.42l2.3 2.3V4.5a1 1 0 0 1 1-1Z"
          :fill="brandColor"/>
        <path d="M5 16.5a1 1 0 0 1 1 1v1.5h12v-1.5a1 1 0 1 1 2 0v2a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 4 19.5v-2a1 1 0 0 1 1-1Z"
          :fill="brandColor"/>
      </g>
    </svg>
    <div class="content">
      <h4>Instale a Recrutei no seu aparelho</h4>
      <p>Abra direto da tela inicial, sem precisar procurar no navegador</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { promptInstall } from '../../services/pwaInstall'

export default {
  name: 'InstallAppCard',
  data() {
    return {
      loading: false,
    }
  },
  computed: {
    // A cor vem da empresa dona do portal, como nos demais tiles do bloco.
    ...mapGetters('company', { brandColor: 'color' }),
  },
  // Quem decide se o convite aparece e o Vacancy, entao montar ja e a impressao.
  mounted() {
    this.track('pwa_install_shown')
  },
  methods: {
    // Tracking nunca derruba o fluxo: instalar e um clique unico na vida.
    track(eventName, props = {}) {
      (async () => {
        try {
          const { trackEvent } = await import('@/services/posthog')
          trackEvent(eventName, props)
        } catch (_) { /* posthog opcional */ }
      })()
    },
    async install() {
      // O card inteiro e clicavel, entao o guarda de reentrancia toma o lugar
      // do `disabled` que o botao tinha: sem ele, dois toques seguidos abrem
      // dois dialogos do navegador.
      if (this.loading) return
      this.loading = true
      this.track('pwa_install_clicked')
      try {
        const outcome = await promptInstall()
        if (outcome) this.track('pwa_install_outcome', { outcome })
        // Aceitar dispara `appinstalled`, e recusar consome o evento do
        // navegador: nos dois casos o `canPromptInstall()` passa a ser falso e
        // o convite sai de cena sozinho, sem marca guardada.
      } catch (_) {
        // O navegador pode ter invalidado o convite antes do clique.
      } finally {
        this.loading = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.install-card {
  .content {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

}
</style>
